import styled from 'styled-components';
import { BREAKPOINTS } from 'styles';

export const StyledContentBackground = styled.div`
  //  background-color: ${({ theme }) => theme.colors.pureWhite};

  ${BREAKPOINTS.tablet} {
  }
`;
